import './ticket_response_view.js.coffee';# Added by Script 
Customer.Dashboard ||= {}

class Customer.Dashboard.WhatsappTicketResponseView extends Customer.Dashboard.TicketResponseView
  template: JST['backbone/templates/customer/ticket/body/response_whatsapp_business']
  className: 'response-box-wrapper'

  disableAttachmentButton: ->
    @attachment._disableAddAttachmenntButton()

  enableAttachmentButton: ->
    @attachment._enableAddAttachmenntButton()

  showResponseWarning: (msg) ->
    @$el.find('#response-form-warning').show()

  hideResponseWarning: ->
    @$el.find('#response-form-warning').hide()
